import { Diagram } from 'src/containers/ProjectDiagram/types/diagram';
import { Model } from 'src/containers/ProjectDiagram/types/model';
import { updateLinkIris } from 'src/containers/ProjectDiagram/utils/updateIris/updateLinkIris';
import { updateModelAttributeIris } from 'src/containers/ProjectDiagram/utils/updateIris/updateModelAttributeIris';
import { updateModelColorIdIris } from 'src/containers/ProjectDiagram/utils/updateIris/updateModelColorIdIris';
import { updateModelDescriptionIris } from 'src/containers/ProjectDiagram/utils/updateIris/updateModelDescriptionIris';
import { updateModelHighlightedKeys } from 'src/containers/ProjectDiagram/utils/updateIris/updateModelHighlightedKeys';
import { updateModelLabelIris } from 'src/containers/ProjectDiagram/utils/updateIris/updateModelLabelIris';
import { updateModelPropertyTypeIris } from 'src/containers/ProjectDiagram/utils/updateIris/updateModelPropertyTypeIris';
import { updateModelSelectionKeys } from 'src/containers/ProjectDiagram/utils/updateIris/updateModelSelectionKeys';
import { updateNodeIris } from 'src/containers/ProjectDiagram/utils/updateIris/updateNodeIris';
import { updateRuleIris } from 'src/containers/ProjectDiagram/utils/updateIris/updateRuleIris';
import { updateSensitivePropertyGroupIris } from 'src/containers/ProjectDiagram/utils/updateIris/updateSensitivePropertyGroupIris';

export const updateIri =
  (prevIri: string, newIri: string) => (model: Model, diagram: Diagram) => {
    // 1. update node keys
    const nodeKeys = updateNodeIris(prevIri, newIri)(model);

    // 2. update link and link label keys, also relationshipIri for relationship mappings
    const linkKeys = updateLinkIris(prevIri, newIri)(model);

    // 3. update model attributes
    updateModelAttributeIris(prevIri, newIri)(model);

    // 4. update model labels
    updateModelLabelIris(prevIri, newIri)(model);

    // 5. update model descriptions
    updateModelDescriptionIris(prevIri, newIri)(model);

    // 6. update model colors
    updateModelColorIdIris(prevIri, newIri)(model);

    // 7. update model property types
    updateModelPropertyTypeIris(prevIri, newIri)(model);

    // 8. update sensitive property groups
    updateSensitivePropertyGroupIris(prevIri, newIri)(model);

    // 9. update rules
    updateRuleIris(prevIri, newIri)(model);

    // 10. update hidden part
    const hiddenPartKeys = diagram.hiddenPart.updateAttributeValue(
      prevIri,
      newIri
    );

    const updatedKeys = {
      ...nodeKeys,
      ...linkKeys,
      ...hiddenPartKeys,
    };

    // 11. update model highlighted and selection
    updateModelHighlightedKeys(updatedKeys)(model);
    updateModelSelectionKeys(updatedKeys)(model);
  };
